// extracted by mini-css-extract-plugin
export default {"resetButton":"SearchIconWithReset-module__resetButton___x5Xk4"};